import React from "react"

import { FormControl, FormHelperText, FormLabel, RadioGroup, Radio } from "@mui/joy";
import { useTranslation} from 'react-i18next';

const InputRadio = (props) => {

    const {t} = useTranslation();

    const {
        editing,
        required,
        name,
        label,
        autoFocus,
        type = "radio",
        hint,
        haserror,
        options = [],
        className = "",
        mirrorField,
        value,
        onChange,
        error,
    } = props;
    let { disabled, readonly } = props;
    if (!editing) readonly = true;
    if (readonly) disabled = true;

  
    const generateOptions = () => {
        return options.map((option, k) => (
            <Radio 
                key={k} 
                value={option.value} 
                label={option.label} 
                disabled={disabled}
            />
        ));
    };

    const invalid = Boolean(error);
    let generalClass = "form-element-control";
    generalClass += (editing) ? " editing" : " reading";
    generalClass += (invalid) ? " error" : "";
    generalClass += (required) ? " required" : "";
    generalClass += (disabled) ? " disabled" : "";
    generalClass += (readonly) ? " readonly" : "";

    return (
        <div className={("form-element radio "+className).trim()}>
            <FormControl error={invalid} className={(error) ? generalClass + " form-element-error" : generalClass}>
                {label ? <FormLabel className="form-element-label" htmlFor={name}>{t(label)} {mirrorField}</FormLabel> : null}
                <RadioGroup
                    id={name}
                    type={type}
                    name={name}
                    value={value}
                    onChange={onChange}
                    variant="outlined"
                    autoComplete="off"
                    autoFocus={autoFocus}
                    disabled={disabled}
                    readOnly={readonly}
                    required={required}
                >
                    {generateOptions()}
                </RadioGroup>
                <FormHelperText className="form-element-hint">
                    {(haserror || error) ? (
                        <>
                            {error ? error.message : 'Messaggio di errore'}
                        </>
                    ) : (
                        <>
                            {hint}
                        </>
                    )}
                </FormHelperText>
            </FormControl>
        </div>
    );
};


export default InputRadio;
